import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-950">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-heading text-xl text-white mb-4">韩漫漫画网站</h3>
            <p className="text-sm text-foreground-300 leading-relaxed">
              韩漫漫画网站是免费韩漫与漫画大全的宝库，提供海量在线漫画资源，并持续为您挖掘和推荐好看的韩国漫画。
            </p>
          </div>
          <div>
            <h4 className="font-heading text-base text-white mb-4">快速链接</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">
                {t('nav.home')}
              </Link>
              <Link to="/category/all" className="block text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">
                {t('nav.category')}
              </Link>
              <Link to="/about" className="block text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap">
                {t('nav.about')}
              </Link>
            </div>
          </div>
          <div>
            <h4 className="font-heading text-base text-white mb-4">{t('about.contact')}</h4>
            <div className="space-y-2 text-sm text-foreground-300">
              <p>邮箱：contact@manhuakr.com</p>
              <p>客服热线：400-123-4567</p>
              <p>工作时间：周一至周五 9:00-18:00</p>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">{t('footer.copyright')}</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">
              {t('footer.privacy')}
            </Link>
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">
              {t('footer.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}